import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { updateCurrentItemIndex } from "appRedux/slices/wishListSlice"
import { useAppSelector } from "appRedux/hooks"

export default function useResolveCurrentItemIndex(list: WishItem[]) {
  const wishListState = useAppSelector((state) => state.wishList)

  const dispatch = useDispatch()

  useEffect(() => {
    if (wishListState.currentItemIndex > -1) return
    if (!wishListState.itemInfo) return
    const index = list.findIndex(item => Number(item.id) === Number(wishListState.itemInfo?.id))
    if (index === -1) return
    dispatch(updateCurrentItemIndex(index))
  }, [wishListState.currentItemIndex, wishListState.itemInfo?.id, list])
}
